<template>
  <div class="fotter">
    <div class="fotter_inside">
      <div class="fotter_one_inside">
        <div>地址：广东省惠州市江北14号小区信合大厦1栋12层03号</div>
        <div>邮编：516003</div>
      </div>
    </div>
    <div class="fotter_inside">
      <div class="fotter_two_inside">
        <div>电话：0752-2891916</div>
        <div>传真：0752－2891916</div>
        <div>E_MAIL：manager@gdcreate.com</div>
      </div>
    </div>
    <div class="fotter_inside">
      <div class="fotter_three_inside">
        <div class="left">
          <div class="left_inside">
            <div>版权所有：广东原创科技有限公司</div>
            <div>Copyright 2016 All rights reserved</div>
          </div>
        </div>
        <div class="right">
          <div class="right_inside">
            <div>备案序号：粤ICP备14040842号</div>
            <div>粤公网安备 44130202000552号 </div>
          </div>
        </div>
      </div>
    </div>
    <div class="QRCode">
      <div class="inside">
        <el-image :src="code" fit="cover"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      code: require('../../assets/二维码.jpg'),
    }
  }
}
</script>

<style lang="scss" scoped>
.fotter{
  min-width: 1024px;
  padding-top: 1.24rem;
  width: 100%;
  height: 8.72rem;
  background: #252A30;
  font-size: 0.56rem;
  .fotter_inside{
    width: 100%;
    height: 0.8rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0.52rem;
    .fotter_one_inside{
      width: 35%;
      height: 100%;
      display: flex;
      justify-content: space-between;
      color: white;
    }
    .fotter_two_inside{
      width: 45%;
      height: 100%;
      display: flex;
      justify-content: space-between;
      color: white;
    }
    .fotter_three_inside{
      width: 69%;
      height: 100%;
      display: flex;
      justify-content: space-between;
      color: white;
      .left{
        width: 45%;
        .left_inside{
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
      }
      .right{
        width: 45%;
        .right_inside{
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
      }
    }
  }
  .QRCode{
    width: 100%;
    height: 4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 0.16rem;
    padding-bottom: 0.4rem;
    .inside{
      width: 3.88rem;
      height: 3.88rem;
      border-radius: 5px;
      .el-image{
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>